import React, { useState } from "react";
import MainSidebar from "../Mainsidebar";
import UserNavbar from "../UserNavbar";
import AllVendorsDashboardTable from "../Vendor/AllVendorsDashboardTable";

const AllVendors = () => {
  const [hamburger, sethamburger] = useState(true);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);

  const handleScreenEnter = () => { setFullScreen(false); document.body.requestFullscreen(); };
  const handleScreenExit = () => { setFullScreen(true); document.exitFullscreen(); };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);

  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) return { width: "100%", left: "0rem" };
    return { width: !hamburger && "-webkit-fill-available", left: !hamburger && "3.7rem" };
  };

  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) return { display: hamburger && "none" };
  };

  return (
    <>
      <div className="con1 d-flex">
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            handelRightMenuShow={handelRightMenuShow}
            handelShow={handelShow}
            isSearchShow={isSearchShow}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
            fullScreen={fullScreen}
          />
          <div className="mt-4 px-3">
            <div className="col-12 d-flex justify-content-center mt-3">
              <div
                className="col-12 border rounded p-3 bg-white"
                style={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)" }}
              >
                <AllVendorsDashboardTable />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllVendors;
